import React from 'react';

export default ({ text="Edit" }) => (
	<div className="tab">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54"><path d="M3.4 20h6.1v5.8H3.4V20zm0 12.1h6.1v5.8H3.4v-5.8zm0 12.2h6.1v5.8H3.4v-5.8zM17.1 20h6.1v5.8h-6.1V20zm0 12.1h6.1v5.8h-6.1v-5.8zm0 12.2h6.1v5.8h-6.1v-5.8zM30.8 20h6.1v5.8h-6.1V20zm0 12.1h6.1v5.8h-6.1v-5.8zm0 12.2h6.1v5.8h-6.1v-5.8zM44.5 20h6.1v5.8h-6.1V20zm0 12.1h6.1V50h-6.1V32.1zM9.5 7.9H3.4v5.8h47.2V7.9H9.5z"/></svg>
		{text}
	</div>
)